import { TextDetail, OrderedProducts } from './index'
import styled from 'styled-components'

const dateTimeToString = (date) => {
    return date.getFullYear() + '-' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '-' + 
        ('00' + date.getDate()).slice(-2) + ' ' + 
        ('00' + date.getHours()).slice(-2) + ':' + 
        ('00' + date.getMinutes()).slice(-2) + ':' + 
        ('00' + date.getSeconds()).slice(-2)
}

const dateToString = (date) => {
    return date.getFullYear() + '-' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '-' + 
        ('00' + date.getDate()).slice(-2) 
}

const OrderHistoryItem = props => {

    const order = props.order
    
    const orderedDatetime = dateTimeToString(order.updated_at.toDate())
    const shippingDate = order.shipping_date ? dateToString(order.shipping_date.toDate()) : ""
    const price = '¥' + order.amount.toLocaleString()

    return (
        <Wrapper>
            <TextDetail label={'ステータス'} value={order.status} />
            <TextDetail label={'注文番号'} value={order.id} />
            <TextDetail label={'注文日時'} value={orderedDatetime} />
            <TextDetail label={'お支払い金額'} value={price} />
            {order.status === "発送完了" && (
                <>
                    <TextDetail label={'発送日'} value={shippingDate} /> 
                    <TextDetail label={'配送業者'} value={order.carrier} /> 
                    <TextDetail label={'追跡番号'} value={order.tracking_id} /> 
                </>
            )}
            {order.products.length > 0 && (
                <OrderedProducts products={order.products} />
            )}
        </Wrapper>
    )
}
export default OrderHistoryItem

const Wrapper = styled.div`
    padding: 20px;
    margin-bottom: 50px;
    box-shadow: 0 0 15px rgba(0,0,0,.3);
    background-color: #111;
`